import { useState, useEffect } from 'react';

export default function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Afficher le CTA après 500px de scroll
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 left-0 right-0 z-40 px-6 pointer-events-none">
      <div className="max-w-4xl mx-auto pointer-events-auto">
        <div className="bg-gradient-to-r from-[#3D2817] to-[#2C1810] rounded-2xl shadow-2xl p-4 flex flex-col sm:flex-row items-center justify-between gap-4 border border-white/10">
          {/* Texte */}
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex w-12 h-12 rounded-full bg-[#E8956F]/20 items-center justify-center flex-shrink-0">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-fire-line text-[#E8956F] text-xl"></i>
              </div>
            </div>
            <div>
              <p className="text-white font-semibold text-sm sm:text-base">Plus que 05 places disponibles</p>
              <p className="text-white/70 text-xs sm:text-sm">La formation débute le 18 décembre</p>
            </div>
          </div>

          {/* Bouton */}
          <a 
            href="https://sophrocavaliers.learnybox.com/formation-endometriose-cavalieres/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-8 py-4 bg-[#E8956F] text-white rounded-full text-base font-semibold hover:bg-[#D67D5A] transition-all shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span>Réserver ma place</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base"></i>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
